import { Route, Routes } from "react-router-dom";
import { lazy, Suspense, useEffect, useState } from "react";
import Sidebar from "../../components/sidebar";
import api from "../../services/api";
const Home = lazy(() => import("../../pages/home/home"));
const ListJishoWord = lazy(() => import("../../pages/jisho-words/list-jisho-word/list-jisho-word"));
const AddJishoWord = lazy(() => import("../../pages/jisho-words/add-jisho-word/add-jisho-word"));
const EditJishoWord = lazy(() => import("../../pages/jisho-words/edit-jisho-word/edit-jisho-word"));
const ListParagraph = lazy(() => import("../../pages/paragraphs/list-paragraph/list-paragraph"));
const AddParagraph = lazy(() => import("../../pages/paragraphs/add-paragraph/add-paragraph"));
const EditParagraph = lazy(() => import("../../pages/paragraphs/edit-paragraph/edit-paragraph"));
const ListAdmin = lazy(() => import("../../pages/admins/list-admin/list-admin"));
const AddAdmin = lazy(() => import("../../pages/admins/add-admin/add-admin"));
const EditAdmin = lazy(() => import("../../pages/admins/edit-admin/edit-admin"));
const ListPermission = lazy(() => import("../../pages/permissions/list-permission/list-permission"));
const AddPermission = lazy(() => import("../../pages/permissions/add-permission/add-permission"));
const EditPermission = lazy(() => import("../../pages/permissions/edit-permission/edit-permission"));

function Main() {
  const [verified, setVerified] = useState(false);

  useEffect(() => {
    let active = true;

    const verify = async () => {
      try {
        const response = await api.post("/admins/verify");
        if (!active) return;

        if (response.data?.success === true) {
          setVerified(true);
        } else {
          window.location.replace("/login");
        }
      } catch (error) {
        if (active) {
          window.location.replace("/login");
        }
      }
    };

    verify();

    return () => {
      active = false;
    };
  }, []);

  // Do not mount the sidebar or dashboard until the server verifies the session.
  if (!verified) return null;

  return (
    <div className="flex w-full min-h-screen bg-gray-100">
      <div className="fixed h-screen w-64">
        <Sidebar />
      </div>

      <div className="flex-1 min-w-0 ml-64 overflow-x-auto">
        <Suspense fallback={<div className="p-6 text-gray-500">Đang tải...</div>}>
          <Routes>
          <Route path="/" element={<Home />} />

          <Route path="/admins" element={<ListAdmin />} />
          <Route path="/admins/add" element={<AddAdmin />} />
          <Route path="/admins/edit/:id" element={<EditAdmin />} />

          <Route path="/permissions" element={<ListPermission />} />
          <Route path="/permissions/add" element={<AddPermission />} />
          <Route path="/permissions/edit/:id" element={<EditPermission />} />

          <Route path="/jisho-words" element={<ListJishoWord />} />
          <Route path="/jisho-words/add" element={<AddJishoWord />} />
          <Route path="/jisho-words/edit/:id" element={<EditJishoWord />} />

          <Route path="/paragraphs" element={<ListParagraph />} />
          <Route path="/paragraphs/add" element={<AddParagraph />} />
          <Route path="/paragraphs/edit/:id" element={<EditParagraph />} />
          </Routes>
        </Suspense>
      </div>
    </div>
  );
}

export default Main;
